import { format } from 'date-fns';

/**
 * Bridge `<input type="time">` (HH:mm) with stored Date values.
 */
export function dateToTimeInputValue(d) {
  if (!d || !(d instanceof Date) || isNaN(d.getTime())) return '';
  return format(d, 'HH:mm');
}

export function timeInputValueToDate(str, referenceDate) {
  if (!str || typeof str !== 'string') return null;
  const [hPart, mPart] = str.split(':');
  const h = parseInt(hPart, 10);
  const m = parseInt(mPart, 10);
  if (Number.isNaN(h) || Number.isNaN(m)) return null;
  const base =
    referenceDate instanceof Date && !isNaN(referenceDate.getTime())
      ? new Date(referenceDate.getTime())
      : new Date();
  base.setHours(h, m, 0, 0);
  return base;
}

/** @typedef {{ hour12: number; minute: number; period: 'AM' | 'PM' }} Time12hParts */

/**
 * Decompose a Date into 12-hour clock parts for dropdowns.
 * @returns {Time12hParts}
 */
export function dateTo12hParts(d) {
  if (!d || !(d instanceof Date) || isNaN(d.getTime())) {
    return { hour12: 9, minute: 0, period: 'AM' };
  }
  const h24 = d.getHours();
  const minute = d.getMinutes();
  const period = h24 >= 12 ? 'PM' : 'AM';
  let hour12 = h24 % 12;
  if (hour12 === 0) hour12 = 12;
  return { hour12, minute, period };
}

/**
 * Build a Date from 12-hour parts, preserving the calendar day of referenceDate when possible.
 * @param {number} hour12 — 1–12
 * @param {number} minute — 0–59
 * @param {'AM' | 'PM'} period
 * @param {Date} [referenceDate]
 */
export function parts12hToDate(hour12, minute, period, referenceDate) {
  const h = Math.min(12, Math.max(1, hour12 | 0));
  const m = Math.min(59, Math.max(0, minute | 0));
  let h24;
  if (period === 'AM') {
    h24 = h === 12 ? 0 : h;
  } else {
    h24 = h === 12 ? 12 : h + 12;
  }
  const base =
    referenceDate instanceof Date && !isNaN(referenceDate.getTime())
      ? new Date(referenceDate.getTime())
      : new Date();
  base.setHours(h24, m, 0, 0);
  return base;
}
